import Vue from 'vue';
import Router from 'vue-router';

import authService from '@/services/authService';
import NProgress from 'nprogress';

import AtlasPage from '@/views/AtlasPage';
import WholeNetworkPage from '@/views/WholeNetworkPage';
import HotListPage from '@/views/HotListPage';
import ConcernPage from '@/views/ConcernPage';
import RecommendPage from '@/views/RecommendPage';

const PdfDetailPage = () => import('@/views/PdfDetailPage');
const CiccRedirect = () => import('@/views/CiccRedirect');
const IndustryPage = () => import('@/views/IndustryPage');
// const MainPage = () => import('@/views/MainPageV2');
const ResultPage = () => import('@/views/ResultPage');
const PersonDetailPage = () => import('@/views/PersonDetailPage');
const TopNewsDetailPage = () => import('@/views/TopNewsDetailPageV2');
const PageTemplate = () => import('@/views/PageTemplate');
const MyCompanies = () => import('@/views/MyCompanies');
const EventListPage = () => import('@/views/EventListPage');
const AreaNewsPage = () => import('@/views/AreaNewsPage');
const EventDetailPage = () => import('@/views/EventDetailPage');
const AlarmSettingsPage = () => import('@/views/AlarmSettingsPage');
const NewLoginPage = () => import('@/views/NewLoginPage');
const SetUsername = () => import('@/views/SetUsername');
const PerfectUserMessage = () => import('@/views/PerfectUserMessage');
const SearchResultPage = () => import('@/views/SearchResultPage');
const AllowRegisterPage = () => import('@/views/AllowRegisterPage');
const MonitorHomePage = () => import('@/views/MonitorHomePage');
const MonitorHomePageNoData = () => import('@/views/MonitorHomePageNoData');
const HotWordsNewsListPage = () => import('@/views/HotWordsNewsListPage');
const BulletinListPage = () => import('@/views/BulletinListPage');
const FollowPage = () => import('@/views/FollowPage');
// const RecommendPage = () => import('@/views/RecommendPage');
// const HotListPage = () => import('@/views/HotListPage');
// const ConcernPage = () => import('@/views/ConcernPage');
// const WholeNetworkPage = () => import('@/views/WholeNetworkPage');
// const AtlasPage = () => import('@/views/AtlasPage');

const LoginPage = () => import(/* webpackPrefetch: true, webpackChunkName: "login-page" */ '@/views/LoginPage');
// const RegisterPage = () => import(/* webpackPrefetch: true, webpackChunkName: "login-page" */ '@/views/RegisterPage');

const NotFoundPage = () => import(/* webpackPrefetch: true, webpackChunkName: "not-found-page" */ '@/views/NotFoundPage');

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '',
      component: PageTemplate,
      meta: {
        requiresAuth: true
      },
      children: [
        // {  
        //   path: '/',
        //   name: 'main-page',
        //   component: MainPage
        // },
        {  
          path: '/',
          name: 'recommend-page',
          component: RecommendPage
        },
        {
          path: '/hot-list',
          name: 'hot-list-page',
          component: HotListPage
        },
        {
          path: '/concern',
          name: 'concern-page',
          component: ConcernPage
        },
        {
          path: '/follow',
          name: 'follow-page',
          component: FollowPage
        },
        {
          path: '/whole-network',
          name: 'whole-network-page',
          component: WholeNetworkPage
        },
        {
          path: '/graph',
          name: 'atlas-page',
          component: AtlasPage
        },
        {
          path: '/industry-page',
          name: 'industry-page',
          component: IndustryPage
        },
        {
          path: '/monitor-home',
          name: 'monitor-home',
          component: MonitorHomePage
        },
        {
          path: '/result',
          name: 'result-page',
          component: ResultPage
        },
        {
          path: '/person',
          name: 'person',
          component: PersonDetailPage
        },
        {
          path: '/search-result',
          name: 'search-result-page',
          component: SearchResultPage
        },
        {  
          path: '/home-no-data',
          name: 'home-no-data',
          component: MonitorHomePageNoData
        },
        // {  
        //   path: '/monitor-home',
        //   name: 'monitor-home',
        //   component: MonitorHomePage
        // },
        {
          path: '/top-news-detail',
          name: 'top-news-detail-page',
          component: TopNewsDetailPage
        },
        {
          path: '/companies',
          name: 'my-companies',
          component: MyCompanies
        }, 
        {
          path: '/event-list',
          name: 'event-list',
          component: EventListPage
        },
        {
          path: '/area-news',
          component: AreaNewsPage
        },
        {
          path: '/event-detail',
          name: 'event-detail',
          component: EventDetailPage
        },
        {
          path: '/pdf-detail',
          name: 'pdf-detail',
          component: PdfDetailPage
        },
        {
          path: '/hot-words-news',
          name: 'hot-words-news',
          component: HotWordsNewsListPage
        },
        {
          path: '/bulletin-page',
          name: 'bulletin-page',
          component: BulletinListPage
        },
        {
          path: '/alarm-settings',
          name: 'alarm-settings',
          component: AlarmSettingsPage
        }
      ]
    },
    {
      path: '/new-login',
      name: 'new-login-page',
      component: NewLoginPage
    },
    {
      path: '/cicc',
      name: 'cicc-redirect',
      component: CiccRedirect
    },
    {
      path: '/set-username',
      name: 'set-username',
      component: SetUsername
    },
    {
      path: '/perfect-user',
      name: 'perfect-user',
      component: PerfectUserMessage
    },
    {
      path: '/allow-register',
      name: 'allow-register',
      component: AllowRegisterPage
    },
    {
      path: '/login',
      name: 'login-page',
      component: LoginPage
    },
    // { 
    //   path: '/register',
    //   name: 'register-page',
    //   component: RegisterPage
    // },
    {
      path: '/*',
      name: 'not-found-page',
      component: NotFoundPage
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!authService.isLoggedIn()) {
      next({
        path: '/new-login',
        query: { redirect: to.fullPath }
      });
    } else {
      NProgress.start();
      next();
    }
  } else {
    NProgress.start();
    next(); // 确保一定要调用 next()
  }
});
router.afterEach(() => {
  NProgress.done();
});

export default router;
